import { baseEnvironment } from './environment.base';

/** Development environment. Loaded when `ng serve` (or `ng build --configuration development`) runs. */
export const environment = {
  ...baseEnvironment,
  support: {
    url:
      baseEnvironment.support.url ?? 'https://supportportal.markant.services/support/tickets/new',
  },
  eserviceApiBase: baseEnvironment.eserviceApiBase,
  baseAccessGroup: baseEnvironment.baseAccessGroup,
  auth0: {
    domain: baseEnvironment.auth0.domain,
    clientId: baseEnvironment.auth0.clientId,
  },
  allowedApiUrls: ['https://accept-um.markant.services/*'],
};
